<template>
  <main-layout>
    <b-loading :is-full-page="true" :active.sync="loading" />
    <div v-if="!loading">
      <!-- <h1 class="title">Modifica {{ estimate.name }}</h1> -->
      <estimate-form :item="estimate" />
      <estimate-lines-form :estimate-id="estimate.id" :lines="lines" />
    </div>
  </main-layout>
</template>

<script>
import { get, call } from "vuex-pathify"
import store from "@/store"

import EstimateForm from "@/components/EstimateForm.vue"
import EstimateLinesForm from "@/components/EstimateLinesForm.vue"
import MainLayout from "@/layouts/Main.vue"

export default {
  components: {
    EstimateForm,
    EstimateLinesForm,
    MainLayout
  },
  data() {
    return {
      loading: true
    }
  },
  computed: {
    estimate: get("estimates/estimate"),
    lines: get("estimateLines/estimateLines")
  },
  async beforeRouteUpdate(to, from, next) {
    this.loading = true
    await this.fetchEstimate(to.params.id)
    await this.fetchEstimateLines(to.params.id)
    this.loading = false
    next()
  },
  beforeDestroy() {
    store.set("estimates/estimate", {})
    store.set("estimateLines/estimateLines", [])
  },
  async mounted() {
    this.loading = true
    await this.fetchEstimate(this.$route.params.id)
    await this.fetchEstimateLines(this.$route.params.id)
    this.loading = false
  },
  methods: {
    fetchEstimate: call("estimates/find"),
    fetchEstimateLines: call("estimateLines/all")
  }
}
</script>

<style lang="sass" scoped>
nav
  margin-top: 2.1rem
.column.is-narrow:first-child
  padding-left: 0
</style>
